import store from "@/store/store";
import TimeStamp from "@/services/timeStamp";
import FirebaseRead from "@/services/database/firebaseRead";
import SPIELER_MEMBERSHIP_HANDLER from "@/services/data/spieler/spielerMembershipHandler";
import EXCEL_DOWNLOAD from '@/utilities/services/downloads/excel/excelDownload';
import SpielService from "@/services/data/spielService";

export class SpielerExport {
    constructor(level, lvId, vereinsId, user) {
        this.level = level // verein, lv, pass
        this.roleFilter = '' // '', 'isSchiedsrichter', 'isTrainer'
        this.landesVerbaende = []
        this.selectedVerbandId = lvId ? lvId : ''
        this.selectedVereinId = vereinsId ? vereinsId : ''
        this.isExporting = false
        this.today = TimeStamp.getTodayString()
        this.spieler = []
        this.saisonId = '1_1_'+ store.state.local.sportJahr.current.id
        if(level==='pass') this.setLandesVerbaende(user)
    }

    disableExport(){
        return (this.roleFilter !== 'isTrainer' &&
                !this.selectedVerbandId && this.level !== 'verein') || this.isExporting
    }

    setLandesVerbaende(user){
        let landesVerbaende = JSON.parse(JSON.stringify( store.state.local.landesverbaende ))
        landesVerbaende = landesVerbaende.map(lv=>({...lv, text: lv.id + ' - ' + lv.name}))
        if ( user.permissions.pass ||  user.permissions.passRead ) {
            landesVerbaende.unshift({
                text: 'Classic-Verbände',
                id: '10', name: 'Vereine', nameShort: 'alle ', sportart: '', wappen: ''
            })
            landesVerbaende.unshift({
                text: 'Bowling-Verbände',
                id: '20', name: 'Vereine', nameShort: 'alle ', sportart: '', wappen: ''
            })
            landesVerbaende.unshift({
                text: 'alle Verbände',
                id: '00', name: 'Vereine', nameShort: 'alle ', sportart: '', wappen: ''
            })
        } else {
            const lvPermissionList= Object.keys(user.permissions).filter(key => key.substring(0,2) === 'lv' )
            landesVerbaende = landesVerbaende.filter(lv => lvPermissionList.includes('lv'+lv.id))
        }
        this.landesVerbaende = landesVerbaende
        this.verifyLVs()
    }

    async exportToExcel(){
        this.isExporting = true
        await this.createSpielerList()
        this.createExcel()
        this.isExporting = false
    }

    async createSpielerList(withoutTechnicalData){
        this.spieler = []
        let spielerMainDocs = await this.getSpielerMainDocs()
        spielerMainDocs = await this.getSpielerMainDocsInaktiv(spielerMainDocs)
        this.spieler = await this.getSpielerPrivateDocs(spielerMainDocs, withoutTechnicalData)
        this.formatSpielerDates()
        console.log ("this.spieler", this.spieler);
    }
        formatSpielerDates(){
            this.spieler.forEach( (spieler) => {
                if ( spieler.geburtsdatum ) spieler.geburtsdatum = TimeStamp.getStringDotDateFromString(spieler.geburtsdatum)
                if ( spieler.ade ) spieler.ade = TimeStamp.getStringDotDateFromString(spieler.ade)
                if ( spieler.attest ) spieler.attest = TimeStamp.getStringDotDateFromString(spieler.attest)
                if ( spieler.dsv ) spieler.dsv = TimeStamp.getStringDotDateFromString(spieler.dsv)
                if ( spieler.gesperrtAb ) spieler.gesperrtAb = TimeStamp.getStringDotDateFromString(spieler.gesperrtAb)
                if ( spieler.passVon ) spieler.passVon = TimeStamp.getStringDotDateFromString(spieler.passVon)
                if ( spieler.passBis ) spieler.passBis = TimeStamp.getStringDotDateFromString(spieler.passBis)
                if ( spieler.role_instr_bis ) spieler.role_instr_bis = TimeStamp.getStringDotDateFromString(spieler.role_instr_bis)
                if ( spieler.role_instr_von ) spieler.role_instr_von = TimeStamp.getStringDotDateFromString(spieler.role_instr_von)
                if ( spieler.role_osr_von ) spieler.role_osr_von = TimeStamp.getStringDotDateFromString(spieler.role_osr_von)
                if ( spieler.role_osr_bis ) spieler.role_osr_bis = TimeStamp.getStringDotDateFromString(spieler.role_osr_bis)
                if ( spieler.role_sr_bis ) spieler.role_sr_bis = TimeStamp.getStringDotDateFromString(spieler.role_sr_bis)
                if ( spieler.role_sr_von ) spieler.role_sr_von = TimeStamp.getStringDotDateFromString(spieler.role_sr_von)
                if ( spieler.role_tr_bis ) spieler.role_tr_bis = TimeStamp.getStringDotDateFromString(spieler.role_tr_bis)
                if ( spieler.role_tr_von ) spieler.role_tr_von = TimeStamp.getStringDotDateFromString(spieler.role_tr_von)
                if ( spieler.role_uel_bis ) spieler.role_uel_bis = TimeStamp.getStringDotDateFromString(spieler.role_uel_bis)
                if ( spieler.role_uel_von ) spieler.role_uel_von = TimeStamp.getStringDotDateFromString(spieler.role_uel_von)
            });
        }

        verifyLVs(){
            this.landesVerbaende.forEach( (lv) => {
                if ( !store.state.realtime.landesverbaende[lv.id] && lv.id !== '10' && lv.id !== '20' ) {
                    this.bindLV(lv.id)
                }
            });
        }

        bindLV(id){
            store.dispatch('bindRealtimeDocument', {
                collection: 'landesverbaende',
                docId: id,
                storeField: 'landesverbaende.' + id,
            });
        }

// SPIELER MAIN DOCS *****************************************

    async getSpielerMainDocs(){
    // load trainers only
        if ( this.roleFilter === 'isTrainer' ){
            return await FirebaseRead.readDocList( 'spieler',
                {field: 'roles.isTrainer', operator: '==', value: true}
            )
        }
    // load all spieler
        if ( this.selectedVerbandId === '00' ) {
            return await this.loadAllSpieler()
        }
    // load all spieler by sportart
        if ( this.selectedVerbandId === '10' || this.selectedVerbandId === '20' ) {
            const sportart = this.selectedVerbandId === '10' ? 'classic' : 'bowling'
            return await this.loadAllSpielerBySportart(sportart)
        }
    // load all spieler for a verein
        if ( this.selectedVereinId ) {
            return await FirebaseRead.readDocList('spieler',
                {field: 'search.lastAktiv.' + this.selectedVereinId, operator: '>=', value: this.today})
        }
    // load all spieler for a lvId
        return await this.loadAllSpielerForLV()
    }
        async loadAllSpieler(){
            if ( this.roleFilter === 'isSchiedsrichter' ) {
                return await FirebaseRead.readDocList( 'spieler',
                    {field: 'roles.isSchiedsrichter', operator: '==', value: true})
            } else {
                return await FirebaseRead.readFullList( 'spieler')
            }
        }

        async loadAllSpielerBySportart(sportart){
            if ( this.roleFilter === 'isSchiedsrichter' ) {
                const lvList = sportart === 'classic' ? ['11','12','13','14','15','16','17','18','19'] :
                                                        ['21','22','23','24','25','26','27','28','29']
                const promiseList = []
                lvList.forEach( (lvId) => {
                    const pr = FirebaseRead.readDocList( 'spieler',
                        {field: 'roles.sr.lvId', operator: '==', value: lvId})
                    promiseList.push(pr)
                    const prOsr = FirebaseRead.readDocList( 'spieler',
                        {field: 'roles.osr.lvId', operator: '==', value: lvId})
                    promiseList.push(prOsr)
                });
                const reply = await Promise.all(promiseList)
                let spielerList = []
                reply.forEach( (replyItem) => {
                    spielerList = [...spielerList, ...replyItem]
                });
                return spielerList
            } else {
                return await FirebaseRead.readDocList( 'spieler',
                    {field: 'sportart', operator: '==', value: sportart})
            }
        }

        async loadAllSpielerForLV(){
            if ( this.roleFilter === 'isSchiedsrichter' ) {
                const sr = await FirebaseRead.readDocList( 'spieler',
                    {field: 'roles.sr.lvId', operator: '==', value: this.selectedVerbandId})
                const osr = await FirebaseRead.readDocList( 'spieler',
                    {field: 'roles.osr.lvId', operator: '==', value: this.selectedVerbandId})
                return [...sr, ...osr]
            } else {
                return await FirebaseRead.readDocList('spieler',
                    {field: 'search.lastAktiv.' + this.selectedVerbandId, operator: '>=', value: this.today})
            }
        }

// INAKTIVE SPIELER MAIN DOCS *****************************************

    async getSpielerMainDocsInaktiv(spielerMainDocs){
    // load all spieler for a verein
        if ( this.selectedVereinId ) return await  this.loadInaktiveSpielerForVerein(spielerMainDocs)
    // return for cases where inactive players are already loaded
        if ( this.roleFilter === 'isTrainer' || this.roleFilter === 'isSchiedsrichter' || // load trainers or schiedsrichter only
             this.selectedVerbandId === '00' || // load all spieler
             this.selectedVerbandId === '10' || this.selectedVerbandId === '20' // load all spieler by sportart
        ) return spielerMainDocs
    // load all spieler for a lvId
        return await this.loadAllInactiveSpielerForLV(spielerMainDocs)
    }

        async loadInaktiveSpielerForVerein(spielerMainDocs){
            const inaktiveSpieler = await FirebaseRead.readDocList('spieler',
                {field: 'search.inaktiv.' + this.selectedVereinId, operator: '==', value: true})
            return [...spielerMainDocs, ...inaktiveSpieler]
        }

        async loadAllInactiveSpielerForLV(spielerMainDocs){
            let inaktiveSpieler = await FirebaseRead.readDocList('spieler',
                {field: 'status', operator: '==', value: 'inaktiv'})
            inaktiveSpieler = inaktiveSpieler.filter(spieler =>
                spieler.search.inaktiv &&
                Object.keys(spieler.search.inaktiv)
                    .map((vereinId) => vereinId.substring(0,2))
                    .indexOf(this.selectedVerbandId) !== -1
            )
            return [...spielerMainDocs, ...inaktiveSpieler]
        }

// SPIELER PRIVATE *****************************************

    async getSpielerPrivateDocs(spielerListe, withoutTechnicalData){
    // load spieler private
        const reply = await this.loadSpielerPrivateDocs(spielerListe)
       //console.log ("reply", reply);
    // map data
        const spielerTotal = spielerListe.map((spieler)=>
        {
            const dates = spieler.dates
            const hatFoto = spieler.url ? 'ja' : 'nein'
            //const passNr = SPIELER_MEMBERSHIP_HANDLER.getLastValidPassNr(spieler.memberships)
            const mainMembership = this.getCurrentMainMembershipForSpieler(spieler)
            const leihe = this.getLeiheForSpieler(spieler)
            const roles = this.getRolesForSpieler(spieler)
            spieler.letzteAenderung = spieler.letzteAenderung ? TimeStamp.getLocalDateAndTime(spieler.letzteAenderung) : '-'
            spieler.tsLastPassPrint = spieler.tsLastPassPrint ? TimeStamp.getLocalDateAndTime(spieler.tsLastPassPrint) : '-'
            spieler.tsLastPlayerPassPrint = spieler.tsLastPlayerPassPrint ? TimeStamp.getLocalDateAndTime(spieler.tsLastPlayerPassPrint) : '-'
            spieler.ak = this.getAltersklasse(spieler)
            delete dates.akHJ
            delete dates.akJahr
            delete dates.firstSportTag
            delete dates.lastSportTag
            delete spieler.dates
            delete spieler.url
            delete spieler.printIsDuplikat
            delete spieler.memberships
            delete spieler.search
            delete spieler.roles
            delete spieler.waitingForPassPrint
            delete spieler.waitingForPlayerPassPrint
            if ( withoutTechnicalData ) {
                delete spieler.tsLastPassPrint
                delete spieler.tsLastPlayerPassPrint
                delete spieler.letzteAenderung
                delete spieler.tsLastPassPrint
                delete spieler.tsLastPassPrint
            }
            return { ...spieler, ...dates, ...leihe, ...mainMembership, ...roles,
                    ...reply.find(spielerPriv => spielerPriv.id === spieler.id),
                    hatFoto: hatFoto,
            }
        }
        )
        //console.log ("spielerTotal", spielerTotal);
        return spielerTotal.sort((a, b) => a.nachname > b.nachname ? 1 : -1);
    }
        async loadSpielerPrivateDocs(spielerListe){
            if ( this.selectedVerbandId === '00' ||
                 this.selectedVerbandId === '10' ||
                 this.selectedVerbandId === '20' ) { // load all private docs
                return await FirebaseRead.readFullCollectionGroup('private')
            } else {
                const promiseList = []
                spielerListe.forEach( (spieler) => {
                    const pr = FirebaseRead.readSingleDoc('spieler/' + spieler.id + '/private', spieler.id)
                    promiseList.push(pr)
                });
                return await Promise.all(promiseList)
            }
        }

        getCurrentMainMembershipForSpieler(spieler){
            const membership = SPIELER_MEMBERSHIP_HANDLER.getLastRegularMembership(spieler.memberships)
            let vereinName = ''
            if ( membership?.lvVereinId ) {
                const lv = membership.lvVereinId.substring(0,2)
                const verein = membership.lvVereinId.replace(lv, '')
                vereinName = store.state.realtime.landesverbaende[lv].vereine[verein]?.name
            }
            return {
                passVon: membership?.from ? membership.from : '',
                passBis: membership?.until ? membership.until : '',
                passVerein: membership?.lvVereinId ? membership.lvVereinId : '',
                passVereinName: vereinName,
                passNr: membership?.passNr ? membership.passNr : '',
            }
        }
        getLeiheForSpieler(spieler){
            const leihe = SPIELER_MEMBERSHIP_HANDLER.getCurrentLeihe(spieler.memberships)
            return {
                leiheVon: leihe?.from ? leihe.from : '',
                leiheBis: leihe?.until ? leihe.until : '',
                leiheVerein: leihe?.lvVereinId ? leihe.lvVereinId : '',
                leihePassNr: leihe?.passNr ? leihe.passNr : '',
            }
        }

        getRolesForSpieler(spieler){
            const roles = spieler.roles
            return {
                role__isSchiedsrichter: roles?.isSchiedsrichter ? 'ja' : 'nein',
                role__isTrainer: roles?.isTrainer ? 'ja' : 'nein',
                role_osr_von: roles?.osr?.von ? roles.osr.von : '',
                role_osr_bis: roles?.osr?.bis ? roles.osr.bis : '',
                role_osr_lvId: roles?.osr?.lvId ? roles.osr.lvId : '',
                role_osr_passNr: roles?.osr?.nr ? roles.osr.nr : '',
                role_sr_von: roles?.sr?.von ? roles.sr.von : '',
                role_sr_bis: roles?.sr?.bis ? roles.sr.bis : '',
                role_sr_lvId: roles?.sr?.lvId ? roles.sr.lvId : '',
                role_sr_passNr: roles?.sr?.nr ? roles.sr.nr : '',
                role_tr_von: roles?.tr?.von ? roles.tr.von : '',
                role_tr_bis: roles?.tr?.bis ? roles.tr.bis : '',
                role_tr_passNr: roles?.tr?.nr ? roles.tr.nr : '',
                role_uel_von: roles?.uel?.von ? roles.uel.von : '',
                role_uel_bis: roles?.uel?.bis ? roles.uel.bis : '',
                role_uel_passNr: roles?.uel?.nr ? roles.uel.nr : '',                
                role_instr_von: roles?.instr?.von ? roles.instr.von : '',
                role_instr_bis: roles?.instr?.bis ? roles.instr.bis : '',
                role_instr_passNr: roles?.instr?.nr ? roles.instr.nr : '',
            }
        }
        getAltersklasse(spieler){
            if ( !spieler.dates?.akHJ ) { return 'unbekannt' }
            return SpielService.getAltersklasse(spieler.dates.akHJ, spieler.dates.akJahr, this.saisonId, spieler.sportart)
        }

    createExcel(){
        if ( this.spieler.length === 0 ) return
        EXCEL_DOWNLOAD.exportJsonToSingleSheet(
            this.spieler,
            'Spieler_',
            TimeStamp.getTodayString(),
            this.getExcelHeaderConfig(),
        );
    }

        getExcelHeaderConfig(){
            return [
                {text:'Sportart', value:'sportart'},

                {text:'Nachname', value:'nachname'},
                {text:'Vorname', value:'vorname'},
                {text:'Titel', value:'titel'},
                {text:'Geschlecht', value:'geschlecht'},
                {text:'Altersklasse', value:'ak'},
                {text:'Geburtsdatum', value:'geburtsdatum'},
                {text:'Geburtsort', value:'geburtsort'},
                {text:'Nationalitaet', value:'nationalitaet'},
                {text:'Foto', value:'hatFoto'},
                {text:'Strasse', value:'strasse'},
                {text:'PLZ', value:'plz'},
                {text:'Ort', value:'ort'},
                {text:'Handy', value:'mobilTelefon'},
                {text:'Telefon', value:'telefon'},
                {text:'eMail', value:'eMail'},
                {text:'Bemerkung', value:'bemerkung'},
                {text:'Handicap', value:'handicap'},

                {text:'Attest', value:'attest'},
                {text:'ADE', value:'ade'},
                {text:'DSV', value:'dsv'},

                {text:'Spieler-Status', value:'status'},
                {text:'Gesperrt ab', value:'gesperrtAb'},
                {text:'AnmeldeTag', value:'AnmeldeTag'},

                {text:'Pass-Nr', value:'passNr'},
                {text:'Pass-Verein', value:'passVerein'},
                {text:'Pass-Verein-Name', value:'passVereinName'},
                {text:'Pass gültig von', value:'passVon'},
                {text:'Pass gültig bis', value:'passBis'},

                {text:'Leihe-Pass-Nr', value:'leihePassNr'},
                {text:'Leihe-Pass-Verein', value:'leiheVerein'},
                {text:'Leihe-Pass gültig von', value:'leiheVon'},
                {text:'Leihe-Pass gültig bis', value:'leiheBis'},
                
                {text:'Letzte Änderung', value:'letzteAenderung'},
                {text:'Letzter Passdruck', value:'tsLastPassPrint'},
                {text:'Letzter Spieler-Passdruck', value:'tsLastPlayerPassPrint'},
                {text:'System-Id', value:'id'},

                {text:'Ist Schiedsrichter', value:'role__isSchiedsrichter'},
                {text:'Ist Trainer', value:'role__isTrainer'},
                {text:'OSR-Nr', value:'role_osr_passNr'},
                {text:'OSR LvId', value:'role_osr_lvId'},
                {text:'OSR von', value:'role_osr_von'},
                {text:'OSR bis', value:'role_osr_bis'},
                {text:'SR-Nr', value:'role_sr_passNr'},
                {text:'SR LvId', value:'role_sr_lvId'},
                {text:'SR von', value:'role_sr_von'},
                {text:'SR bis', value:'role_sr_bis'},
                {text:'TR-Nr', value:'role_tr_passNr'},
                {text:'TR von', value:'role_tr_von'},
                {text:'TR bis', value:'role_tr_bis'},
                {text:'UEL-Nr', value:'role_uel_passNr'},
                {text:'UEL von', value:'role_uel_von'},
                {text:'UEL bis', value:'role_uel_bis'},
                {text:'INSTR-Nr', value:'role_instr_passNr'},
                {text:'INSTR von', value:'role_instr_von'},
                {text:'INSTR bis', value:'role_instr_bis'},
            ]
                /*[
                { text: 'KugelNr', value: 'nr' },
                { text: 'Besitzer-Typ', value: 'ownerType' },
                { text: 'Besitzer', value: 'ownerName' },
                { text: 'Geburtsdatum', value: 'geburtsdatum' },
                { text: 'Gültig bis', value: 'gueltigBis' },
                { text: 'Kommentar', value: 'kommentar' },
                { text: 'Sportart', value: 'sportart' },
                { text: 'Erstellt am', value: 'tsCreated' },
                { text: 'Erstellt von', value: 'createdByName' },
                { text: 'Zuletzt geändert am', value: 'tsLastUpdated' },
                { text: 'Zuletzt geändert von', value: 'lastUpdatedByName' },
                { text: 'Zuletzt gedruckt am', value: 'tsLastPassPrint' },
                { text: 'Wartet auf Druck', value: 'waitingForPassPrint' },
            ]*/

        }

}